<template >
    <div class="content-wrapper">
        <Header></Header>
        <div style="position: absolute;width:70px ; font-size: 20px;margin-left: 30px;margin-top: 10px;cursor: pointer"
            @click="to">
            <i
                class="el-icon-arrow-left
                                                                                                                                                                                                                                                                                                                                                                        "></i>
            返回
        </div>

        <div class="qyhy1">
            <img src="../../assets/img/qyhy1.png" alt="">
        </div>
        <div class="qyhy2">
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm" class="demo-ruleForm">
                <div class="qyhy2-con">
                    <div class="qyhy2-con-text">留下您的信息 </div>
                    <div class="qyhy2-con-text">我们的课程顾问将协助您获取<span style="color:#fc750d">免费试用</span>权限</div>
                    <div class="qyhy2-con-mobile">
                        <div class="title"> 您的手机号 </div>
                        <div class="inputS">
                            <el-form-item prop="mobile"> <el-input style="width:230px" v-model="ruleForm.mobile" clearable
                                    placeholder="请输入您的手机号" maxlength="11"></el-input></el-form-item>
                        </div>
                    </div>
                    <div class="qyhy2-con-city">
                        <div class="title"> 您所在的城市 </div>
                        <div class="inputS">
                            <el-form-item prop="city"> <el-cascader placeholder="请选择城市" style="width:230px"
                                    :options="options" v-model="ruleForm.city"
                                    :props="{ value: 'cityName', label: 'cityName', children: 'citys' }"
                                    clearable></el-cascader></el-form-item>

                        </div>
                    </div>
                    <div class="qyhy2-con-btn">
                        <el-button style="background:#F69264;color: #fff; margin: 0 auto; width: 120px;" type="warning"
                            round @click="submitForm('ruleForm')">提交</el-button>
                    </div>
                </div>
            </el-form>
        </div>
        <div class="qyhy3"></div>
        <div class="qyhy4">
            <h1>VIP会员超值权益备份</h1>
            <p>智慧教育 · 组织赋能</p>
        </div>
        <div class="qyhy5"></div>
        <div class="qyhy4">
            <h1>数智赋能-智慧工具：汇学堂SaaS</h1>
            <p>企业人员财税学习云平台</p>
        </div>
        <div class="qyhy6"></div>
        <div class="qyhy7"></div>
        <div class="qyhy4">
            <h1>财税智慧公开课系列</h1>
            <p>——精进致用 全环节全领域 一体化学习</p>
        </div>
        <div class="qyhy8"></div>
        <div class="qyhy9"></div>
        <div class="qyhy4">
            <h1>高端考察研学系列</h1>
        </div>
        <div class="qyhy10"></div>
        <div class="qyhy11"></div>
        <div class="qyhy12"></div>
        <div class="qyhy13"></div>
        <div class="qyhy14"></div>
        <div class="qyhy15"></div>
        <div class="qyhy16"></div>
        <br /> <br /> <br />

        <el-dialog :before-close="handleClose" :visible.sync="dialogVisible" width="30%">
            <img style="width:550px" src="../../assets/img/subOpen.png" alt="">

        </el-dialog>
    </div>
</template>
<script>
import moduleName from '../../utils/city2.json';
import Header from '@/components/Header.vue'

import {
    submitContact, userBaseInfo
} from '@/api/index.js';

export default {
    name: "",
    components: {
        Header,
    },
    data() {
        return {
            TopDeptId: "",
            dialogVisible: false,
            token: null,
            ruleForm: { mobile: "", city: '', origin: 1, },
            rules: {
                mobile: [{ required: true, message: '请输入手机号码', trigger: 'change' },
                {
                    pattern: /^1[3|4|5|6|7|8|9][0-9]\d{8}$/,
                    message: "请输入正确的手机号码",
                    trigger: "blur"
                }
                ],
                city: [
                    { required: true, message: '请选择您所在的城市', trigger: 'change' }
                ],
            },
            messageData: {},
            options: moduleName,

            active: 1,
            zdUrl: "", acyiveTab: 1,
        };
    },
    created() {

        this.token = window.localStorage.getItem("token");
        this.TopDeptId = window.localStorage.getItem("TopDeptId");
        if (this.$route.params.type) {
            this.origin = this.$route.params.type
        }


        this.getuserBaseInfo()
    },
    mounted() {

    },

    methods: {
        getuserBaseInfo() {
            userBaseInfo({}, { Authorization: this.token, TopDeptId: this.TopDeptId }).then(res => {
                console.log(res, 'lbjcbsdb')
                if (res.code == 200) {
                    console.log(res.data.mobile)
                    this.ruleForm.mobile = res.data.mobile ? res.data.mobile : ''
                }


            })

        },

        to() {
            this.$router.push({ path: '/' })

        },
        handleClose() {
            this.dialogVisible = false
            this.$refs['ruleForm'].resetFields();
        },
        //提交

        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.captcha()
                    //  this.subAPI()
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        //滑块验证
        captcha() {
            var _this = this;
            var captcha = new TencentCaptcha('2000842234',
                function (res) {
                    if (res.ret == 0) {


                        var city = _this.ruleForm.city
                        submitContact({
                            ticket: res.ticket,
                            randstr: res.randstr,
                            mobile: _this.ruleForm.mobile,
                            origin: _this.ruleForm.origin,
                            city: city[1], province: city[0],
                        }, { Authorization: _this.token ? _this.token : '' }).then(res => {
                            if (res.code == 200) {
                                _this.dialogVisible = true
                            }
                        })
                    }
                }
            );
            captcha.show();
        },



    }

};
</script>
<!-- 调用   <mycom></mycom> -->
<style scoped   lang="less">
.content-wrapper {
    width: 100%;
    margin-top: 100px;
    background: #FFFFFF;
    min-height: 600px;
}




.qyhy1 {
    cursor: pointer;
    width: 100%;

    // height: 584px;
    // background: url('../../assets/img/qyhy1.png') no-repeat;
    // background-size: 100% 100%;
    img {
        width: 100%;
    }
}

.qyhy2 {

    cursor: pointer;
    width: 100%;
    height: 627px;
    background: url('../../assets/img/qyhy2.png') no-repeat;
    background-size: 100% 100%;
    margin-bottom: 100px;

    padding-top: 1px;

    .qyhy2-con {

        width: 600px;
        margin: 0 auto;
        margin-top: 150px;

        .qyhy2-con-text {
            text-align: center;
            font-size: 30px;
            font-weight: 600px
        }
    }

    .qyhy2-con-mobile,
    .qyhy2-con-city {

        margin-top: 20px;

        width: 450px;

        height: 60px;
        background: #FFFFFF;
        border-radius: 40px;
        line-height: 60px;
        color: #666666;
        display: flex;
        margin: 25px auto;


        .title {
            width: 250px;

            text-align: center;
        }




    }

    .qyhy2-con-btn {
        display: flex;
        width: 600px;

    }
}

.qyhy3 {

    width: 1200px;
    margin: 0 auto;
    height: 1084px;
    background: url('../../assets/img/qyhy3.png') no-repeat;
    background-size: 100% 100%;
    margin-bottom: 100px;
}

.qyhy4 {
    width: 1200px;
    margin: 0 auto;
    margin-bottom: 50px;

    h1 {
        font-size: 40px;
    }

    p {

        font-size: 20px;
    }
}

.qyhy5 {

    width: 1200px;
    margin: 0 auto;
    height: 662px;
    background: url('../../assets/img/qyhy5.png') no-repeat;
    background-size: 100% 100%;
    margin-bottom: 100px;
}

.qyhy6 {

    width: 1200px;
    margin: 0 auto;
    height: 300px;
    background: url('../../assets/img/qyhy6.png') no-repeat;
    background-size: 100% 100%;
    margin-bottom: 100px;
}

.qyhy7 {

    width: 1200px;
    margin: 0 auto;
    height: 767px;
    background: url('../../assets/img/qyhy7.png') no-repeat;
    background-size: 100% 100%;
    margin-bottom: 100px;
}

.qyhy8 {

    width: 1200px;
    margin: 0 auto;
    height: 738px;
    background: url('../../assets/img/qyhy8.png') no-repeat;
    background-size: 100% 100%;
    margin-bottom: 100px;
}

.qyhy9 {

    width: 1200px;
    margin: 0 auto;
    height: 778px;
    background: url('../../assets/img/qyhy9.png') no-repeat;
    background-size: 100% 100%;
    margin-bottom: 100px;
}

.qyhy10 {

    width: 1200px;
    margin: 0 auto;
    height: 701px;
    background: url('../../assets/img/qyhy10.png') no-repeat;
    background-size: 100% 100%;
    margin-bottom: 100px;
}

.qyhy11 {

    width: 1200px;
    margin: 0 auto;
    height: 589px;
    background: url('../../assets/img/qyhy11.png') no-repeat;
    background-size: 100% 100%;
    margin-bottom: 100px;
}

.qyhy12 {

    width: 1200px;
    margin: 0 auto;
    height: 690px;
    background: url('../../assets/img/qyhy12.png') no-repeat;
    background-size: 100% 100%;
    margin-bottom: 100px;
}

.qyhy13 {

    width: 1200px;
    margin: 0 auto;
    height: 464px;
    background: url('../../assets/img/qyhy13.png') no-repeat;
    background-size: 100% 100%;
    margin-bottom: 100px;
}

.qyhy14 {

    width: 1200px;
    margin: 0 auto;
    height: 1148px;
    background: url('../../assets/img/qyhy14.png') no-repeat;
    background-size: 100% 100%;
    margin-bottom: 100px;
}

.qyhy15 {

    width: 1200px;
    margin: 0 auto;
    height: 923px;
    background: url('../../assets/img/qyhy15.png') no-repeat;
    background-size: 100% 100%;
    margin-bottom: 100px;
}

.qyhy16 {

    width: 1200px;
    margin: 0 auto;
    height: 617px;
    background: url('../../assets/img/qyhy16.png') no-repeat;
    background-size: 100% 100%;
    margin-bottom: 100px;
}

.inputS ::v-deep .el-input__inner {
    border: none !important;
    // outline: none !important;
    height: 60px;
    border-radius: 40px;

}
</style>
